// @flow

import React, { useState, useEffect } from "react";
import LiveSearchInput from "../common/LiveSearchInput";
import SelectCourses from "../common/SelectCourses";
import apiFetch from "../utils/_apiFetch";
import { getTranslationCatalog } from "../utils/_i18n.js";
import Vocabulary from "../utils/_vocabulary.js";
import type { SearchCoursesTileContainerState } from "../utils/_types.js";
import { set } from "immutable";

const SearchCoursesTileComponent = ({ formAction }: { formAction: string }) => {
  const [courses, setCourses] = useState([]);
  const [translations, setTranslations] = useState({});
  const [vocabulary, setVocabulary] = useState({});
  const [courseTypes, setCourseTypes] = useState([]);
  const [courseType, setCourseType] = useState("");
  const [searchableText, setSearchableText] = useState("");

  useEffect(() => {
    const portal_url = document.body
      ? document.body.getAttribute("data-portal-url")
      : "";
    const fetches = [
      apiFetch({
        url: portal_url + "/@search",
        params: {
          portal_type: "Course",
          metadata_fields: [
            "course_type",
            "Description",
            "class_code",
            "UID",
            "external_website",
          ],
          b_size: 200,
        },
        method: "GET",
        restApi: true,
      }),
      getTranslationCatalog(),
      Vocabulary.getVocabularies("unife.vocabularies", ["CourseTypes"]),
    ];

    Promise.all(fetches).then(([searchResults, trans, vocab]) => {
      const types = [
        ...new Set(
          searchResults.items
            .map((course) => course.course_type)
            .filter(Boolean)
            .sort()
        ),
      ];

      setCourses(searchResults.items);
      setCourseTypes(types);
      setTranslations(trans);
      setVocabulary(vocab);
    });
  }, []);

  const onUpdateSelectedCourse = (value: string): void => {
    setCourseType(value);
  };

  const onUpdateSearchableText = (value: string): void => {
    setSearchableText(value);
  };

  const filteredCourses = courseType.length
    ? courses.filter((course) => course.course_type === courseType)
    : courses;

  const searchHelp =
    translations && translations.search_course_help ? (
      <p className="course-search-help">{translations.search_course_help}</p>
    ) : (
      ""
    );

  return (
    <div className="course-search-wrapper">
      {searchHelp}
      <form action={formAction} method="GET">
        <input type="hidden" name="portal_type" value="Course" />
        <SelectCourses
          courseTypes={courseTypes}
          onUpdateSelect={onUpdateSelectedCourse}
          course_type={courseType}
          translations={translations}
          vocabulary={vocabulary}
        />
        <LiveSearchInput
          courses={filteredCourses}
          course_type={courseType}
          onUpdate={onUpdateSearchableText}
          SearchableText={searchableText}
          translations={translations}
          vocabulary={vocabulary}
        />
        <button type="submit" className="btn">
          {translations.search_button_text}
        </button>
      </form>
    </div>
  );
};

export default SearchCoursesTileComponent;
